import { ProblemType } from '@/static/enums/problemType';

/**
 * Map of labels to translate a problem type.
 */
export const ProblemTypeToLabel: Record<ProblemType, string> = {
  [ProblemType.VALIDATION_ERRORS]: 'problem.type.validationErrors',
  [ProblemType.NOT_OPENED_IN_TARN]: 'problem.type.notOpenedInTarn',
  [ProblemType.NOT_IN_SYNC_WITH_TR_OPENED]: 'problem.type.notOpenedInTr',
  [ProblemType.NOT_IN_SYNC_WITH_TR_CLOSED]: 'problem.type.notClosedInTr',
  [ProblemType.NOT_IN_SYNC_WITH_TR_OTHER]: 'problem.type.notInSyncWithTr',
  [ProblemType.NOT_IN_SYNC_WITH_TARN]: 'problem.type.notInSyncWithTarn',
  [ProblemType.NOT_NOT_CLOSED_IN_TARN]: 'problem.type.notClosedInTarn',
  [ProblemType.NOT_NOT_REOPENED_IN_TARN]: 'problem.type.notReOpenedInTarn',
  [ProblemType.NOT_NOT_PARTIALLY_CLOSED_IN_TARN]: 'problem.type.notPartiallyClosedInTarn',
  [ProblemType.NOT_NOT_STOPPED_IN_TARN]: 'problem.type.notStoppedInTarn',
  [ProblemType.NOT_NOT_UNSTOPPED_IN_TARN]: 'problem.type.notUnStoppedInTarn',
};
